import React from 'react';
import { IllustrationButtonChildren, StyledBlankButton, } from './IllustrationButton.styles';
export const IllustrationButton = ({ illustration, children, dataCy, ...buttonProps }) => {
    const css = buttonProps.css || {};
    return (
    // @ts-ignore
    React.createElement(StyledBlankButton, { ...buttonProps, "data-cy": dataCy, css: css },
        illustration,
        React.createElement(IllustrationButtonChildren, { "data-cy": `${dataCy}-children` }, children)));
};
IllustrationButton.defaultProps = {};
export default IllustrationButton;
